import * as React from 'react'
import styled from 'styled-components'
import { Button } from '@ui-library/core'
import { ArrowRightBold } from '@ui-library/icons'

export const CustomUIIcon = styled(ArrowRightBold)``

export const CustomUIButton = styled(Button)`
  padding: 0px;
  font-size: 14px;
  line-height: 18px;
  height: 18px;
  font-weight: 400;
  color: ${props => props.color};
  cursor: pointer;

  &:disabled {
    color: ${props => props.color};
    cursor: pointer;
  }

  ${CustomUIIcon} {
    & > use {
      fill: ${props => props.color};
    }
  }
`

const HeaderLinkBoxButton = ({ buttonConfig, link }) => {
  if (buttonConfig.hasArrow && buttonConfig.color) {
    return (
      <CustomUIButton disabled size="medium" kind="primary" color={buttonConfig.color} variant="text" icon={CustomUIIcon} iconPosition="right">
        {link}
      </CustomUIButton>
    )
  }
  return (
    <Button size="medium" kind="primary" variant="normal">
      {link}
    </Button>
  )
}

export default HeaderLinkBoxButton
